import { render, staticRenderFns } from "./LootboxContent.vue?vue&type=template&id=63e3e910&"
import script from "./LootboxContent.vue?vue&type=script&lang=js&"
export * from "./LootboxContent.vue?vue&type=script&lang=js&"
import style0 from "./LootboxContent.vue?vue&type=style&index=0&id=63e3e910&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports